import useSWR, { SWRConfiguration } from 'swr';

import { GetAllAsync } from '../../services/api';
import { Facilitator, User } from '../../types/user';
import { KendoGridResult } from '../../types/KendoGridResult';
import { UserResponse } from '../../types/responses/user-response';

const UserEndpoint = `users`;

export const useGetAllUsers = (
  params?: string,
  type?: 'network' | 'organisation',
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<KendoGridResult<User>>(
    `${UserEndpoint}${type === 'organisation' ? '' : '/network'}?${params}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};

export const useGetAdminUsers = (
  params?: string,
  isPermissions?: boolean,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<UserResponse>
  >(
    `admin/users${isPermissions ? '/permissions' : ''}?${params}`,
    GetAllAsync,
    options
  );

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};

export const useGetFacilitatorUsers = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<Facilitator>
  >(`${UserEndpoint}/facilitators?${params}`, GetAllAsync, options);

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};

export const useGetAdminFacilitatorUsers = (
  params?: string,
  options?: SWRConfiguration
) => {
  const { data, error, isLoading, mutate } = useSWR<
    KendoGridResult<Facilitator>
  >(`admin/facilitators?${params}`, GetAllAsync, options);

  if (error) console.log(error);

  return {
    data,
    isLoading,
    isError: error,
    mutate
  };
};
